/* Publish by EComposer at 2026-10-11 06:37:02*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4baxsgi644p"]=  window.__ectimmers["ecom-4baxsgi644p"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-4baxsgi644p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4baxsgi644p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xjpwb0z7m7b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xjpwb0z7m7b', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}